module.exports = __webpack_public_path__ + "static/media/achievement_03.1ac20030.png";